import SpriteSymbol from "../../../../../doctor/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../doctor/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "IconChecksMark",
  "use": "IconChecksMark-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"IconChecksMark\"><path d=\"M12.227 5L8 9.227l-.94-.94 4.227-4.227.94.94zm2.826-.94L16 5l-8 8-3.727-3.727.94-.94L8 11.113l7.053-7.053zM.5 9.273l.947-.94 3.72 3.727-.94.94L.5 9.273z\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol